import { Page } from './pages/page'
import { EventItem, ItemList, Location } from '@tixa/schema'
import { getPageData } from './utils/ajax'
import { observable } from 'knockout-decorators'

import './components/list-event/list-event'
import './components/page-sidebar/page-sidebar'
import './components/subpage-header/subpage-header'
import './components/item-event/item-event.less'
import './venue.less'

export class VenuePage extends Page {
  public location: Location
  public events: ItemList<EventItem>
  @observable public address = ''
  @observable public gMapsSrc = ''
  @observable public hasImage = false

  private readonly isGmapsDisabled =
    import.meta.env.VITE_DISABLE_GMAPS === 'true'
  private readonly mapApiKey = this.isGmapsDisabled
    ? ''
    : import.meta.env.VITE_GMAPS_API_KEY
  private imageURL: string | null = null

  constructor() {
    super()

    this.location = getPageData<Location>('locationData') || {
      '@type': '',
      logo: '',
      events: [],
      url: '',
      address: {
        '@type': 'PostalAddress',
        postalCode: '',
        addressLocality: '',
        streetAddress: '',
        addressRegion: '',
        addressCountry: '',
        countryCode: '',
      },
      images: [],
      name: '',
      hasMap: '',
    }

    this.events = getPageData<ItemList<EventItem>>('locationEvents') || {
      '@context': '',
      '@type': '',
      itemListOrder: 'Ascending',
      name: '',
      url: '',
      numberOfItems: 0,
      itemListElement: [],
    }

    if (this.location.images && this.location.images.length > 0) {
      this.hasImage = true
      this.imageURL = this.location.images[0]
    }

    this.address = `${this.location.address.postalCode} ${this.location.address.addressLocality}, ${this.location.address.streetAddress}`
    const locationQuery = this.location.hasMap
      ? this.location.hasMap
      : `${this.location.name} ${this.address}`
    this.gMapsSrc = `https://www.google.com/maps/embed/v1/place?key=${
      this.mapApiKey
    }&q=${encodeURIComponent(locationQuery)}`
  }
}

// eslint-disable-next-line @typescript-eslint/no-unused-vars
const page = new VenuePage()
